import { domain } from '@/utils/env';
/**
 * Due to some security issues, so verification code must be used in correct place.
 * So 1 code to 1 behavior is needed here.
 *
 * Used in some apis where it will send verification code.
 *    - send mail verification code
 *    - send phone verification code
 */

// email register and code verification.
export const SECURITY_MAIL_REG_AND_VERIFY = 1;

// using email to bind google 2FA and code verification.
export const SECURITY_MAIL_2FA_AND_VERIFY = 2;

// using email to bind phone and code verification.
export const SECURITY_MAIL_BIND_PHONE_AND_VERIFY = 3;

// forget email password
export const SECURITY_MAIL_FORGET_PWD = 4;

// phone register and code verification.
export const SECURITY_PHONE_REG_AND_VERIFY = 5;

// using phone to bind google 2FA and code verification.
export const SECURITY_PHONE_2FA_AND_VERIFY = 6;

// using phone to bind email and code verification.
export const SECURITY_PHONE_BIND_MAIL_AND_VERIFY = 7;

// forget phone password
export const SECURITY_PHONE_FORGET_PWD = 8;

// using email to set or update anti_phishing_code and code verification.
export const SECURITY_MAIL_ANTI_PHISHING_CODE_AND_VERIFY = 14;

// 封禁国家
export const BAN_COUNTRY_CODES = ['CN'];

// child account register and code verification.
export const SECURITY_MAIL_CHILD_REG_AND_VERIFY = 1;

// child account register and code verification.
export const SECURITY_PHONE_CHILD_REG_AND_VERIFY = 5;
// 通过错误码展示手机号错误
export const BAN_COUNTRY_ERROR_CODES = [31018];

// 提币地址是否需要加tag，来判断是否是交易所的地址

export const ADDRESS_IS_EXCHANGE = ['XRP', 'EOS'];

// 20095地址校验错误

export const CHECK_ADDRESS_IS_EXCHANGE = 20095;

// qq行为验证appid更改
// bybit域名使用v2，其他域名使用v1，后端v1并没有使用只是便于理解。
export const notUseNewVersions = ['bybit'];
export const KEY_VERSION = notUseNewVersions.includes(domain) ? 'v2' : 'v1';
